import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router"; 
import { AuthGuard } from "../services/auth.guard";
import { RecruiterInternalComponent } from "./recruiter-internal.component";
import { CompanyProfileComponent } from "./company-profile/company-profile.component";
import { SubscriptionPlansComponent } from "./subscription-plans/subscription-plans.component";
import { InventoryComponent } from "./subscription-plans/inventory/inventory.component";
import { CheckoutComponent } from "./subscription-plans/checkout/checkout.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { AddressComponent } from "./subscription-plans/address/address.component";
const routes: Routes = [
  { path: "", component: RecruiterInternalComponent,
     children:[
      { path: "company-profile", component: CompanyProfileComponent }, 
      { path: "edit-profile", component: EditProfileComponent }, 
      { path: "subscription", component: SubscriptionPlansComponent }, 
      { path: "inventory", component: InventoryComponent }, 
      { path: "address/:id", component: AddressComponent }, 
      { path: "checkout/:id", component: CheckoutComponent }, 
      { path: "",canActivate: [AuthGuard],loadChildren: () => import("src/app/recruiter-components/recruiter-components.module").then(m => m.RecruiterComponentsModule)}, 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecruiterRoutingModule {}